import { SearchInput } from '@/components/common';

interface PhoneNumberSearchProps {
    disabled?: boolean;
    isLoading?: boolean;
    hasData?: boolean;
    maxWidth?: string;
    phoneNumber?: string;
    setPhoneNumber: (value: string) => void;
    clearPhoneNumber: () => void;
}

/**
 * Phone number search component for calls list.
 */
const PhoneNumberSearch: React.FC<PhoneNumberSearchProps> = (props) => {
    const {
        disabled = false,
        isLoading = false,
        hasData = true,
        maxWidth = '300px',
        phoneNumber,
        setPhoneNumber,
        clearPhoneNumber,
    } = props;

    const isDisabled = disabled || isLoading || (!hasData && !phoneNumber);

    return (
        <SearchInput
            defaultValue={phoneNumber || ''}
            placeholder="Phone number..."
            onChange={setPhoneNumber}
            onClear={clearPhoneNumber}
            disabled={isDisabled}
            minLength={4}
            maxLength={15}
            maxWidth={maxWidth}
        />
    );
};

export default PhoneNumberSearch;
